import React, { useEffect, useRef } from 'react';
import Type from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { ActivityIndicator, EmptyState } from 'components';
import { useTranslation } from 'hooks';
import { usePayments } from 'hooks/api/cascade';
import { useAbortRequest } from 'utils/useAbortRequest';
import { PaymentList } from './components';

const PaymentsScreen = (props) => {
  const { listHeight } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { entityId } = useParams();
  const { abortSignal } = useAbortRequest();
  const {
    status,
    isError,
    error,
    data: operations,
  } = usePayments(entityId, abortSignal);
  const listRef = useRef(null);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderOperations = () => {
    const hasOperations = operations.length !== 0;

    if (!hasOperations) {
      return <EmptyState title={t('noPaymentsByCurrentCustomer')} />;
    }

    return (
      <PaymentList
        ref={listRef}
        listHeight={listHeight}
        operations={operations}
      />
    );
  };

  const renderFetchState = () => {
    switch (status) {
      case 'loading':
        return <ActivityIndicator />;
      case 'success':
        return renderOperations();
      default:
        return null;
    }
  };

  return <>{renderFetchState()}</>;
};

PaymentsScreen.propTypes = {
  listHeight: Type.number.isRequired,
};

export default PaymentsScreen;
